import { toast } from "sonner";

type ToastType = "success" | "error" | "info" | "warning";

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
}

const defaultMessages: Record<ToastType, { title: string; description?: string }> = {
  success: {
    title: "Sucesso!",
    description: "Operação realizada com sucesso.",
  },
  error: {
    title: "Erro",
    description: "Ocorreu um erro. Tente novamente.",
  },
  info: {
    title: "Informação",
  },
  warning: {
    title: "Atenção",
  },
};

export function useAppToast() {
  const showToast = (type: ToastType, options?: ToastOptions) => {
    const defaults = defaultMessages[type];
    const title = options?.title ?? defaults.title;
    const description = options?.description ?? defaults.description;
    const duration = options?.duration ?? 4000;

    switch (type) {
      case "success":
        toast.success(title, { description, duration });
        break;
      case "error":
        toast.error(title, { description, duration });
        break;
      case "info":
        toast.info(title, { description, duration });
        break;
      case "warning":
        toast.warning(title, { description, duration });
        break;
    }
  };

  return {
    success: (options?: ToastOptions) => showToast("success", options),
    error: (options?: ToastOptions) => showToast("error", options),
    info: (options?: ToastOptions) => showToast("info", options),
    warning: (options?: ToastOptions) => showToast("warning", options),
  };
}

// Mensagens padronizadas para ações comuns
export const toastMessages = {
  save: {
    success: { title: "Salvo!", description: "Alterações salvas com sucesso." },
    error: { title: "Erro ao salvar", description: "Não foi possível salvar. Tente novamente." },
  },
  delete: {
    success: { title: "Excluído!", description: "Item excluído com sucesso." },
    error: { title: "Erro ao excluir", description: "Não foi possível excluir. Tente novamente." },
  },
  create: {
    success: { title: "Criado!", description: "Item criado com sucesso." },
    error: { title: "Erro ao criar", description: "Não foi possível criar. Tente novamente." },
  },
  update: {
    success: { title: "Atualizado!", description: "Alterações aplicadas com sucesso." },
    error: { title: "Erro ao atualizar", description: "Não foi possível atualizar. Tente novamente." },
  },
  auth: {
    loginSuccess: { title: "Bem-vindo!", description: "Login realizado com sucesso." },
    loginError: { title: "Erro no login", description: "Verifique suas credenciais e tente novamente." },
    logoutSuccess: { title: "Até logo!", description: "Você saiu da sua conta." },
    registerSuccess: { title: "Conta criada!", description: "Verifique seu e-mail para confirmar o cadastro." },
    registerError: { title: "Erro no cadastro", description: "Não foi possível criar sua conta. Tente novamente." },
  },
};
